import React from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { useMount, useUnmount } from 'react-use';

import { useAppErrors } from '../../../../common/contexts/app-error-context';
import { longPressLocationChanged } from '../../../../common/store/item-edit';
import { namedRoute } from '../../../../common/utils/helpers/routes';
import ErrorView from '../error-view/ErrorView';

const ErrorPage = () => {
  const { appErrors, clearErrors } = useAppErrors();

  const dispatch = useDispatch();
  useMount(() => {
    dispatch(longPressLocationChanged(null));
  });

  useUnmount(() => {
    clearErrors();
  });

  if (!appErrors || appErrors.length === 0) {
    return <Redirect to={namedRoute('root')} />;
  }

  return <ErrorView error={appErrors[0].error || {}} />;
};

export default ErrorPage;
